import DateTime from '@dealroadshow/uikit-date-time';
import { YEAR_MONTH_DAY_DASH_FORMAT } from '@dealroadshow/uikit-date-time/dateFormats';
import { UTC_TIME_ZONE } from '@framework/timezone/constants';

export const getTodayDate = (): string => new DateTime(new Date(), { timeZone: UTC_TIME_ZONE })
  .format(YEAR_MONTH_DAY_DASH_FORMAT);
